import Script from './Script'

export default function BaseScripts({
  scripts,
  classOverwriteName = '',
  isScripts,
  currentScript,
  handleClickScript,
}: {
  scripts: (string | null)[]
  classOverwriteName?: string
  isScripts: boolean
  currentScript: number
  handleClickScript: (_scriptNumber: number, _event: React.MouseEvent) => void
}) {
  return (
    <div
      className={`${classOverwriteName}-container`}
      style={{
        borderRadius: '4px',
        display: 'flex',
        flex: 1,
      }}
    >
      {scripts
        .filter((script) => {
          return script !== null
        })
        .map((script, index) => (
          <Script
            key={index}
            className={classOverwriteName}
            index={index}
            isScripts={isScripts}
            currentScript={currentScript}
            handleClickScript={handleClickScript}
          >
            {script}
          </Script>
        ))}
    </div>
  )
}
